import { render, staticRenderFns } from "./appVersionList.vue?vue&type=template&id=2a982e60&scoped=true"
import script from "./appVersionList.vue?vue&type=script&lang=js"
export * from "./appVersionList.vue?vue&type=script&lang=js"
import style0 from "./appVersionList.vue?vue&type=style&index=0&id=2a982e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a982e60",
  null
  
)

export default component.exports